module.exports = __webpack_public_path__ + "media/images/about/time/2-183f5fda628346ebec695d69bd4cc014.png";